import { ColDef } from "ag-grid-community";
import * as CDs from "src/app/utility/commonColDef";
import { PreprocessDateTime } from "src/app/utility/view-field-mapping";

export const TrustedServiceColumnDefinition: ColDef[] = [
  {
    headerName: "Service",
    field: "ServiceName",
  },
  CDs.ServiceTreeId,
  {
    headerName: "Trusted Service",
    field: "TrustedServiceName",
  },
  {
    headerName: "Trusted ServiceTree Id",
    field: "TrustedServiceTreeId",
  },
  CDs.CreatedBy,
  {
    ...CDs.CreatedTime,
    cellRenderer: (params) => PreprocessDateTime(params.value),
  },
];
